// Module
var code = "<div ng-if=\"$ctrl.groups.length > 1 && $ctrl.group.brands.length > 1\" class=\"cu-pb-1 cu-text-truncate cu-w-100\" ng-bind=\"::$ctrl.group.name\"></div> <div class=\"cu-text-ui-copy-2 cu-text-truncate cu-pb-1 cu-w-100\" ng-bind=\"::$ctrl.brandName\"></div> ";
// Exports
module.exports = code;